/**
 * Frete das remessas e flag "sem frete e sem remessa impressa" (profile_client.is_shipment_exempt).
 * Onde o flag tem efeito e a base de frete das remessas vêm prontos da API (ShipmentExemptionPolicy);
 * aqui não há regra de "é avaliação/simulado". O frete das remessas é cobrado no pedido principal/complementar.
 */
export interface ShipmentFreightItem {
  quantidade_pedido: number;
  is_shipment_exempt?: boolean;
  shipment_exemption_applies?: boolean;
  // Por unidade: soma do product_price dos SKUs impressos das remessas geradas pelo produto
  scheduled_shipment_freight_base?: number | null;
}

// Avaliações e Simulados: descrição começando com "Avaliaç…" ou "Simulad…" (sem acento, singular ou plural).
const SHIPMENT_EXEMPTION_DESCRIPTION_PATTERN = /^(avaliac|simulad)/;

/**
 * Produto em que o flag é oferecido na tela de vínculo. O efeito (sem remessa e sem frete) continua decidido pela
 * API (shipmentExemptionApplies): em produto que não gera remessa o flag fica gravado sem mudar nada.
 */
export const isShipmentExemptionCandidateDescription = (description?: string | null): boolean => {
  if (!description) return false;
  const normalized = description.normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim().toLowerCase();
  return SHIPMENT_EXEMPTION_DESCRIPTION_PATTERN.test(normalized);
};

/** Item isento: não gera remessa impressa e não entra em nenhuma base de frete. */
export const isShipmentExemptItem = (item: Partial<ShipmentFreightItem>): boolean =>
  !!item.is_shipment_exempt && !!item.shipment_exemption_applies;

/** Base (R$) das remessas dos itens do pedido, sobre a qual incide a taxa de frete do cliente. */
export const getScheduledShipmentFreightBaseTotal = (items: Partial<ShipmentFreightItem>[]): number =>
  items.reduce((total, item) => {
    if (isShipmentExemptItem(item) || item.scheduled_shipment_freight_base == null) return total;
    return total + Math.max(Number(item.quantidade_pedido) || 0, 0) * Number(item.scheduled_shipment_freight_base);
  }, 0);
